import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { TokenService } from 'src/app/core/service/autenticacao/token.service';

@Directive({
  selector: '[temPermissao]'
})
export class TemPermissaoDirective {
  private permissao: string = '';

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set temPermissao(funcionalidade: string) {
    this.permissao = funcionalidade;
    this.AtualizarVisibilidade();
  }

  private AtualizarVisibilidade() {
    const possui = TokenService.PossuiFuncionalidade(this.permissao);
    this.viewContainer.clear();

    if (possui) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}